import { ReceptionDeliveryKind } from "../items";

// 交付先
export class ReceptionDelivery {
  public type: ReceptionDeliveryKind = new ReceptionDeliveryKind();
  public generalFlag1: boolean;
  public zipCode: string;
  public address: string;
  public note: string;

  clone(): ReceptionDelivery {
    const newObj = new ReceptionDelivery();
    newObj.type = this.type;
    newObj.generalFlag1 = this.generalFlag1;
    newObj.zipCode = this.zipCode;
    newObj.address = this.address;
    newObj.note = this.note;

    return newObj;
  }
}
